import { Brand, getBrandFromHostname } from '@lendi/lala-utils';
import { BOT_FIRSTNAME_AUSSIE, BOT_FIRSTNAME_DOMAIN, BOT_FIRSTNAME_LENDI, PRIVACY_POLICY_LINK_AUSSIE, PRIVACY_POLICY_LINK_LENDI, } from './constants';
export var isDomain = getBrandFromHostname() === Brand.Domain;
export var getPrivacyPolicyLink = function (brand) {
    switch (brand) {
        case Brand.Aussie:
            return PRIVACY_POLICY_LINK_AUSSIE;
        case Brand.Lendi:
        default:
            return PRIVACY_POLICY_LINK_LENDI;
    }
};
export var getFirstNameForBrand = function () {
    var brand = getBrandFromHostname();
    switch (brand) {
        case Brand.Aussie:
            return BOT_FIRSTNAME_AUSSIE;
        case Brand.Domain:
            return BOT_FIRSTNAME_DOMAIN;
        case Brand.Lendi:
        default:
            return BOT_FIRSTNAME_LENDI;
    }
};
// this check the application scoped and return applicationId if there is an application else undefined
export function checkApplicationScope() {
    var pathNameArray = window.location.pathname.split('/');
    var indexOfApplicationId = pathNameArray.indexOf('application') + 1;
    var urlParamApplicationId = indexOfApplicationId && pathNameArray[indexOfApplicationId];
    return urlParamApplicationId;
}
//# sourceMappingURL=index.js.map